import {
  FormSectionState,
  FormState,
  STOCK_TANK_FIELDS,
  TankTransferFormState,
} from '@navstation-portal/reporting/data-model/vessel-report';
import { StockVm } from '@navstation-portal/reporting/data-model/vessel-report';
import { areTankFieldsValid, isSectionValid } from '../vm-builder-helpers';

export function buildStockVm(formState: FormState): StockVm {
  const isFuelWaterRobValid = isSectionValid(formState['fuelWaterRob']);
  const isLubeOilRobValid = isSectionValid(formState['lubeOilRob']);
  const isOilLossesValid = isSectionValid(formState['oilLosses']);
  const stockFuelTotals = calculateStockFuelTotals(formState['tanks']);
  const hasDuplicateTanksSelected: boolean = (() => {
    const tankTransfersSection = formState['tankTransfers'] as TankTransferFormState;
    if (!tankTransfersSection || !Array.isArray(tankTransfersSection['transfers'])) {
      return false;
    }

    const tankIds = tankTransfersSection['transfers'].reduce((ids: string[], transfer) => {
      if (transfer.from.value) ids.push(transfer.from.value.code.$oid);
      if (transfer.to.value) ids.push(transfer.to.value.code.$oid);
      return ids;
    }, []);

    const uniqueTankIds = new Set(tankIds);
    return uniqueTankIds.size < tankIds.length;
  })();

  const isTanksValid = areTankFieldsValid(formState['tanks'], STOCK_TANK_FIELDS);
  const isTankTransfersValid = isSectionValid(formState['tankTransfers'], true);

  const isStockValid =
    isLubeOilRobValid &&
    isOilLossesValid &&
    isFuelWaterRobValid &&
    isTanksValid &&
    isTankTransfersValid &&
    !hasDuplicateTanksSelected;
  return {
    hasDuplicateTanksSelected,
    isStockValid,
    stockFuelTotals,
  };
}

function calculateStockFuelTotals(tanks: FormSectionState): Map<string, number> {
  const tankRows = tanks?.['tankRows'] || [];
  const totalsMap = new Map<string, number>();
  Object.values(tankRows).forEach((tank) => {
    const fuelGrade: string = (tank.fuelGrade?.value?.code as string) || 'UNKNOWN';
    const amount = tank.amount?.value || 0;

    if (totalsMap.has(fuelGrade)) {
      totalsMap.set(fuelGrade, (totalsMap.get(fuelGrade) ?? 0) + amount);
    } else {
      totalsMap.set(fuelGrade, amount);
    }
  });

  return totalsMap;
}
